import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import * as React from 'react'

import { RECAP_YEAR } from '../../App.constants'
import { Localized } from '../../localization/react'

import ShareIconSVG from './assets/share-icon.svg'

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  isLoading: boolean
}

const RecapOverviewSharingButton = ({ onClick, isLoading }: Props) => {
  return (
    <Stack width="100%" gap={5} sx={{ paddingX: 2 }} data-exclude="true">
      <button
        style={{ paddingTop: '10px', paddingBottom: '10px' }}
        className={`hover:bg-surface-brand-primary/90 m-auto w-fit rounded-md bg-surface-brand-primary px-4 ${
          isLoading && 'disabled:pointer-events-none disabled:opacity-50'
        }`}
        disabled={isLoading}
        onClick={onClick}
      >
        <Stack direction="row" alignItems="center" position="relative" sx={{ textTransform: 'none' }} gap={2}>
          <img src={ShareIconSVG} width="12px" height="12px" />
          <Text sx={{ color: 'white', fontSize: '16px', fontWeight: 500 }}>
            <Localized id="yearly-recap-share-button" params={{ year: RECAP_YEAR }} />
          </Text>
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="size-2 animate-spin rounded-full border-2 border-solid border-border-brand-secondary border-t-transparent" />
            </div>
          )}
        </Stack>
      </button>
      <Text variant="xsmall" textAlign="center" sx={{ color: 'rgba(255, 255, 255, 0.70)' }}>
        <Localized id="yearly-recap-online-bookings-only-disclaimer" />
      </Text>
    </Stack>
  )
}

export default RecapOverviewSharingButton
